import React, { useEffect } from "react";
import RedoIcon from "./icons/redo";
import Table from "./icons/table";
import UndoIcon from "./icons/undo";
import { Tooltip } from "antd";

export default function CustomToolbar() {
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const tooltip = document.querySelector(".ql-tooltip");
      if (tooltip) {
        const left = parseInt(tooltip.style.left, 10);
        if (left < 0) {
          tooltip.style.left = "0px";
        }
      }
    });
  
    const container = document.querySelector(".ql-editor");
    if (container) {
      observer.observe(container, { childList: true, subtree: true, attributes: true });
    }
  
    return () => observer.disconnect();
  }, []);
  return (
    <div id="toolbar" 
      style={{
      border: "none",
      background: "transparent",
      
    }}>
      <span className="ql-formats" style={{ background: "#F8FAFC", border: "1px solid #E2E8F0", borderRadius: "4px" }}>
        <Tooltip title={"Undo"}><button className="ql-undo"><UndoIcon color="#0F172A" height="12" width="14" /></button></Tooltip>
        <Tooltip title={"Redo"}><button className="ql-redo"><RedoIcon color="#0F172A" height="12" width="14" /></button></Tooltip>
      </span>
      <span className="ql-formats" style={{ background: "#F8FAFC", border: "1px solid #E2E8F0", borderRadius: "4px" }}>
        <Tooltip title="Bold"><button className="ql-bold" /></Tooltip>
        <Tooltip title="Italic"><button className="ql-italic" /></Tooltip>
        <Tooltip title="Underline"><button className="ql-underline" /></Tooltip>
        <Tooltip title="Strike"><button className="ql-strike" /></Tooltip>
      </span>
      <Tooltip title="Font"><span className="ql-formats" style={{ background: "#F8FAFC", border: "1px solid #E2E8F0", borderRadius: "4px" }}>
        <select className="ql-font" defaultValue="manrope" style={{ width: "50px" }}>
          <option value="manrope">Aa</option>
        </select>
        <select className="ql-size" defaultValue="14px" style={{ width: "50px" }}>
          <option value="12px">12</option>
          <option value="14px">14</option>
          <option value="16px">16</option>
          <option value="18px">18</option>
          <option value="24px">24</option>
          <option value="32px">32</option>
        </select>
        <select className="ql-header" defaultValue="">
          <option value="1">H1</option>
          <option value="2">H2</option>
          <option value="3">H3</option>
          <option value="4">H4</option>
          <option value="5">H5</option>
          <option value="6">H6</option>
          <option value="">Normal</option>
        </select>
        <select className="ql-color" />
      </span></Tooltip>

      <span className="ql-formats" style={{ background: "#F8FAFC", border: "1px solid #E2E8F0", borderRadius: "4px", }}>
        <Tooltip title="Bullet List"><button className="ql-list" value="bullet" /></Tooltip>
        <Tooltip title="Ordered List"><button className="ql-list" value="ordered" /></Tooltip>
        <Tooltip title="Indent Left"><button className="ql-indent" value="-1" /></Tooltip>
        <Tooltip title="Indent Right"><button className="ql-indent" value="+1" /></Tooltip>
      </span>
      <span className="ql-formats" style={{ background: "#F8FAFC", border: "1px solid #E2E8F0", borderRadius: "4px", }}>
        <Tooltip title="Left"><button className="ql-align" value=""></button></Tooltip>
        <Tooltip title="Center"><button className="ql-align" value="center"></button></Tooltip>
        <Tooltip title="Right"><button className="ql-align" value="right"></button></Tooltip>
        <Tooltip title="Justify"><button className="ql-align" value="justify"></button></Tooltip>
      </span>
      <span className="ql-formats" style={{ background: "#F8FAFC", border: "1px solid #E2E8F0", borderRadius: "4px" }}>
      <Tooltip title="Table"><button className="ql-insertTable"><Table/></button></Tooltip>
        <Tooltip title="Link"><button className="ql-link" /></Tooltip>
        <Tooltip title="Image"><button className="ql-image" /></Tooltip>
      </span>
    </div>
  );
}


